import React from 'react';
import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';

/**
 * Elige una mesa del salón. allowOccupied=false (mover mesa, unir) solo deja elegir mesas libres;
 * con true (pasar ítems) también las ocupadas, que reciben los ítems en su cuenta.
 */
const PickTableDialog = ({ open, title, description, areas, excludeTableIds = [], allowOccupied, onClose, onPick }) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
    <DialogTitle>{title}</DialogTitle>
    <DialogContent dividers>
      {description && <Typography color="text.secondary" variant="body2" sx={{ mb: 2 }}>{description}</Typography>}
      {areas.map((area) => (
        <Box key={area.id} sx={{ mb: 2 }}>
          <Typography variant="subtitle2" gutterBottom>{area.name}</Typography>
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
            {area.tables
              .filter((table) => !excludeTableIds.includes(table.id))
              .map((table) => {
                const disabled = table.occupied && !allowOccupied;
                return (
                  <Button
                    key={table.id}
                    variant="outlined"
                    color={table.occupied ? 'warning' : 'primary'}
                    disabled={disabled}
                    onClick={() => onPick(table)}
                    sx={{ flexDirection: 'column', minWidth: 84, py: 1 }}
                  >
                    {table.name}
                    <Chip size="small" label={table.occupied ? 'Ocupada' : 'Libre'} sx={{ mt: 0.5, height: 18, fontSize: 11 }} />
                  </Button>
                );
              })}
          </Stack>
        </Box>
      ))}
      {areas.every((area) => area.tables.length === 0) && <Typography color="text.secondary">No hay mesas.</Typography>}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancelar</Button>
    </DialogActions>
  </Dialog>
);

export default PickTableDialog;
